/* eslint-disable no-console */
//  Save visitors navigation time
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { useEffect, useState } from "react";

function visitors() {
  const [user, setUser] = useState("");

  useEffect(() => {
    FingerprintJS.load()
      .then((fp) => fp.get())
      .then((result) => {
        setUser(result.visitorId);
      });
  }, [user]);
  fetch("https://administracionbiugb.ugb.edu.sv/api/webusers/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      fingerprint: `${user}`,
    }),
  })
    .then((response) => response.json())
    .catch(() => {});
}

export default visitors;
